import React from "react";
import DoyDiffComponent from "./DoyDiffComponent";
import AfmDiffComponent from "./AfmDiffComponent";

//TODO: do type inheritance
export interface DiffProps {
  diff: any;
}

const DiffComponent: React.FC<DiffProps> = ({ diff }) => {
  return <div>{JSON.stringify(diff)}</div>; //Test component
};

const componentMap: {
  [key: string]: {
    component: React.FC<DiffProps>;
    props: (diff: any) => DiffProps;
  };
} = {
  "1": {
    component: AfmDiffComponent,
    props: (diff) => ({ diff }),
  },
  "2": {
    component: DiffComponent,
    props: (diff) => ({ diff }),
  },
  "4": {
    component: DiffComponent,
    props: (diff) => ({ diff }),
  },
  "5": {
    component: DoyDiffComponent,
    props: (diff) => ({ diff }),
  },
  "6": {
    component: DiffComponent,
    props: (diff) => ({ diff }),
  },
  "7": {
    component: DiffComponent,
    props: (diff) => ({ diff }),
  },
};

export default function useDiffComponentFactory(type: number) {
  const componentInfo = componentMap[type?.toString()];
  if (!componentInfo) {
    throw new Error(`No component found for type: ${type}`);
  }
  return componentInfo;
}
